import React from "react";
import { useNavigate } from "react-router-dom";
import Icon from "rc-app/components/Icons";

interface AddButtonProps {
  label: string;
  navigateTo?: string;
  onClick?: () => void;
  className?: string;
  iconClassName?: string;
  iconName?: string;
  bgColor?: string;
}

const AddButton: React.FC<AddButtonProps> = ({
  label,
  navigateTo,
  onClick,
  className = "",
  iconClassName = "w-4 h-4",
  iconName='ic-plus',
  bgColor = "bg-[#008564]",
  
}) => {
  const navigate = useNavigate();

  const handleClick = () => {
    if (onClick) {
      onClick();
    } else if (navigateTo) {
      navigate(navigateTo);
    }
  };

  return (
    <button
      onClick={handleClick}
      // className={`${bgColor} text-white font-semibold text-sm px-4 py-2 rounded-lg flex items-center gap-2 hover:opacity-90 transition-opacity ${className}`}
      className={`${bgColor} bg-[#008564] text-white font-semibold text-xs md:text-sm px-2 md:px-4 py-1 md:py-2 rounded-lg flex items-center md:gap-2 hover:opacity-90 transition-opacity ${className}`}

    >
      <Icon name={iconName} className={iconClassName} />
      {label}
    </button>
  );
};


export default AddButton;
